import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "@mui/material";
import { useId, useState } from 'react';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

const CardPergunta = (props: { title: string; text: string; }) => {
	const accessibility = useAccessibility();
	const [open, setOpen] = useState<boolean>(false);
	const id = useId();

	return (
		<div 
			className="pergunta-card"
			onClick={() => { setOpen(!open) }}
			style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}
			role="button"
			tabIndex={0}
			aria-expanded={open}
			aria-controls={`collapse-${id}`}
		>
			<div className="pergunta-card-header" >
				<span dangerouslySetInnerHTML={{ __html: props.title }} />
				<FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
			</div>
			<Collapse in={open}>
				<span
					aria-live="polite"
					id={`collapse-${id}`}
					style={accessibility.textStyleAccessibility} 
					dangerouslySetInnerHTML={{ __html: props.text }} 
				/>
			</Collapse>
			
		</div>
		
	)

}

export default CardPergunta;